export default __webpack_public_path__ + "static/media/aws-opsworks.256b938a.svg";